import React from "react";
import styles from "./About.module.scss"

export default function SignIn() {
    return (<div className={styles.home}>
        <p>Any request, suggestion, or any issue? You can contact me <a href="https://www.linkedin.com/in/paul-darius-sarmadi-715035a4/">here</a>.</p>
    </div>)
}